import { useDebugValue } from 'react';

import { generatedKeys } from '@app/data/queryKeysFactory';
import { useQuery } from '@app/QueryClient';
import { freemiumLoyaltyMemberInsights } from '@app/Services/LoyaltyProgramme';
import { useQueryString } from '@zeal/zeal-lib';

const { freemiumLoyalty } = generatedKeys;

export function useMemberInsights() {
	const [{ from, to, last_from, last_to }] = useQueryString();

	const q = useQuery({
		queryFn: freemiumLoyaltyMemberInsights,
		staleTime: Infinity,
		queryKey: freemiumLoyalty?.memberInsights?.({
			from,
			to,
			last_from,
			last_to,
		}) as string[],
	});
	useDebugValue(q);

	return { ...q, data: q.data?.data };
}
